import { API } from 'action-types/api';

export const resetError = (endpoint: string) => {
    return { type: API.RESET_ERROR, endpoint };
};
